// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"9322defd","431":"f711895a","689":"d50a4230","768":"f51e71cd"}[chunkId] + ".chunk.css";
};